import PartsPopup from "../AppSpecificConpnents/PartsTable/PartsPopup";
import TypesPopup from "../AppSpecificConpnents/Types/TypesPopup";
import TaskPopup from "../../pages/Tasks/TaskPopup";
import ProjectIdPopup from "../../pages/AddModule/ProjectId.jsx/ProjectIdPopup";
import CategoryPopup from "../../pages/Category/CategoryPopup";
import TrainingLogPopup from "../../pages/TrainingLog/TrainingLogPopup";

const TablePopups = ({ showTablePopup, closePopup }) => {
  if (!showTablePopup.show) return null;

  return (
    <>
      {showTablePopup.type === "parts" && (
        <PartsPopup setPartsModalOpen={closePopup} disableFilter={false} />
      )}
      {showTablePopup.type === "type" && (
        <TypesPopup closeTypesModal={closePopup} />
      )}
      {showTablePopup.type === "tasks" && (
        <TaskPopup closeModal={closePopup} />
      )}
      {showTablePopup.type === "projects" && (
        <ProjectIdPopup onClose={closePopup} />
      )}
      {showTablePopup.type === "category" && (
        <CategoryPopup onClose={closePopup} addRow={true} />
      )}
      {showTablePopup.type === "trainingLog" && (
        <TrainingLogPopup onClose={closePopup} />
      )}
    </>
  );
};

export default TablePopups;

